import { useTranslation } from 'react-i18next';
import { SupportEmailAiAnalysisStatus } from '../types/support-email-request.types';

type Props = {
    status: SupportEmailAiAnalysisStatus;
};

const SupportEmailAiAnalysisStatusBadge = ({ status }: Props) => {
    const { t } = useTranslation();

    const labelKey =
        status === SupportEmailAiAnalysisStatus.Pending
            ? 'supportEmailRequests.aiStatus.pending'
            : status === SupportEmailAiAnalysisStatus.Completed
              ? 'supportEmailRequests.aiStatus.completed'
              : status === SupportEmailAiAnalysisStatus.Failed
                ? 'supportEmailRequests.aiStatus.failed'
                : 'supportEmailRequests.aiStatus.skipped';

    const className =
        status === SupportEmailAiAnalysisStatus.Completed
            ? 'bg-primary-10 text-primary'
            : status === SupportEmailAiAnalysisStatus.Failed
              ? 'bg-destructive/10 text-destructive'
              : status === SupportEmailAiAnalysisStatus.Pending
                ? 'bg-warning/10 text-warning'
                : 'bg-lightgray text-gray';

    return (
        <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${className}`}>
            {t(labelKey)}
        </span>
    );
};

export default SupportEmailAiAnalysisStatusBadge;
